import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { VaultService } from '../services/vault/vault.service';
import { PinCodeService } from '../services/pin-code/pin-code.service';

@Injectable({
  providedIn: 'root',
})
export class PincodeGuard implements CanActivate {
  constructor(private vault: VaultService, private pincodeSvc: PinCodeService) {}

  async canActivate() {
    if (this.vault.state.isLocked) {
      await this.unlock();
    }
    return true;
  }

  private async unlock() {
    return await this.pincodeSvc.unlock();
  }
}
